import { render, staticRenderFns } from "./MealDetails.vue?vue&type=template&id=835dc486&scoped=true"
import script from "./MealDetails.vue?vue&type=script&lang=js"
export * from "./MealDetails.vue?vue&type=script&lang=js"
import style0 from "./MealDetails.vue?vue&type=style&index=0&id=835dc486&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835dc486",
  null
  
)

export default component.exports